import { Component, OnInit, OnDestroy, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'casual-order-form-intro',
    templateUrl: './intro.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButton]
})
export class HireFormIntroComponent implements OnInit, OnDestroy {


    // @Private Properties
    private _unsubscribeAll: Subject<any> = new Subject;


    /**
    * Constructor
    */
    constructor(
        private _activatedRoute: ActivatedRoute,
        private _router: Router
    ) { }


    //--------------------------------------------------------------------------------
    // @Lifecycle Hooks
    //--------------------------------------------------------------------------------

    /**
    * OnInit
    */
    ngOnInit(): void {

        this._activatedRoute.url.subscribe({
            next: (s) => {
                console.log(s)
            }
        })
    }

    /**
    * OnDestroy
    */
    ngOnDestroy() {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    //--------------------------------------------------------------------------------
    // @Public Methods
    //--------------------------------------------------------------------------------

    /**
     * 
     */
    public goToFirstStep() {
        this._router.navigate(['select-institution'], { relativeTo: this._activatedRoute.parent})
    }

}